import {Dispatch, SetStateAction, useEffect, useRef} from 'react';
import {standardFormat} from '../utils';

export const handleFilterList = (value: string | string[], name: string, filterQuery: Record<string, any>, setFilterQuery: Dispatch<SetStateAction<any>>, date: string | null = null) => {
    if (date) {
        setFilterQuery({
            ...filterQuery,
            [name ? `${name}_before` : 'before']: value[1] ? standardFormat(value[1]) : null,
            [name ? `${name}_after` : 'after']: value[0] ? standardFormat(value[0]) : null
        });
    }
    else {
        setFilterQuery({
            ...filterQuery,
            [name]: value
        });
    }
};

export const useFilterQuery = (filterQuery: Record<string, any>, filterList: (item: string, tableType: string | null) => void, tableType: string | null = null) => {
    const isFirstRender = useRef(true);
    const initialFilterQuery = useRef(filterQuery);

    useEffect(() => {
        // cette condition empêche les requêtes inutile à l'initialisation du composant parent
        if (!isFirstRender.current || JSON.stringify(filterQuery) !== JSON.stringify(initialFilterQuery.current)) {
            isFirstRender.current = false;
    
            if (filterQuery) {
                const queryParams: string[] = [];
                    
                Object.entries(filterQuery).forEach(([columnName, filterValue]) => {
                    if (filterValue || filterValue === 0) {
                        queryParams.push(`${columnName}=${filterValue}`);
                    }
                });
            
                const stringQueryParams = queryParams.join('&');
            
                filterList(stringQueryParams, tableType);
            }
        }
    }, [filterQuery]);
};
